export * from './rate-component-config.interface';
